export const FAQ_LAYOUTS = {
  DEFAULT: 'default',
  SIDEBAR: 'sidebar',
  TWO_COLUMN_SIDEBAR: 'twoColumnSidebar',
}
